// <product-form>: añade al carrito con la Ajax Cart API (cart-store.js). Sin JS, el formulario de Shopify envía a /cart/add.
// Anuncia «Añadido: …» en una región de estado y abre el carrito lateral. Sin variante elegida, explica qué falta;
// si Shopify lo rechaza (422, sin stock) o falla la red, lo dice junto al botón.
import { addItems } from './cart-store.js';

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('[data-section="main-product"]');
    this.product = JSON.parse(this.section.querySelector('[data-product-json]').textContent);
    this.form = this.querySelector('form');
    this.button = this.querySelector('[data-add-button]');
    this.idInput = this.querySelector('[data-variant-id]');
    this.status = this.querySelector('.product__form-status');
    this.variant = null;
    this.busy = false;
    document.addEventListener('variant:change', (event) => {
      if (event.detail.productHandle === this.product.handle) this.onVariant(event.detail.variant);
    });
    if (this.section.variantState) this.onVariant(this.section.variantState.variant);
    this.form.addEventListener('submit', (event) => this.onSubmit(event));
  }

  onVariant(variant) {
    this.variant = variant;
    this.idInput.value = variant?.id ?? '';
    if (!this.button) return;
    const unavailable = variant && !variant.available;
    this.button.disabled = Boolean(unavailable);
    this.button.textContent = unavailable ? this.product.strings.unavailable : this.product.strings.addToCart;
  }

  describe(variant) {
    const name = this.product.title.split(' (')[0];
    const parts = this.product.options.map((option, i) => `${option.toLowerCase()} ${variant.options[i].length > 2 ? variant.options[i].toLowerCase() : variant.options[i]}`);
    return [name, ...parts].join(', ');
  }

  async onSubmit(event) {
    event.preventDefault();
    if (!this.button || this.busy) return;
    if (!this.variant) {
      this.section.querySelector('variant-picker')?.showMissing(this.product.strings.selectOptions);
      return;
    }
    if (!this.variant.available) {
      this.status.textContent = this.product.strings.outOfStock;
      return;
    }
    const variant = this.variant;
    const quantity = Math.max(1, Number.parseInt(this.form.elements.quantity?.value, 10) || 1);
    this.busy = true;
    this.status.textContent = '';
    try {
      await addItems([{ id: variant.id, quantity }]);
    } catch (error) {
      // 422: Shopify no tiene stock de esa variante (o ya está todo en el carrito). Sin código: no hay conexión.
      this.status.textContent = error.status === 422 ? this.product.strings.outOfStock : this.product.strings.networkError;
      return;
    } finally {
      this.busy = false;
    }
    const message = this.product.strings.added.replace('{{ title }}', () => this.describe(variant));
    this.status.textContent = message;
    document.dispatchEvent(new CustomEvent('cart:open', { detail: { opener: this.button, announcement: message } }));
  }
}

customElements.define('product-form', ProductForm);
